import { Link } from "react-router-dom";

const Unauthorized = () => {
  return (
    <div className="p-6 text-center">
      <h2 className="text-2xl font-bold text-red-600">Unauthorized Access</h2>
      <p className="text-gray-700">You do not have permission to view this page.</p>
      <Link to="/" className="text-blue-500 underline">Go to Home</Link>
    </div>
  );
};

export default Unauthorized;
